import { Box, Grid, Paper, Tooltip, Typography } from "@mui/material";
import { Clamp } from "~/components/clamp/clamp";
import { FrameworkIcon } from "~/pages/compliance/Framework/FrameworkIcon";
import { AvailableFrameworkConfirmDialog } from "./AvailableFrameworkConfirmDialog";
import { Space } from "~/lib/types";
import { Flex } from "~/components/Flex";
import { ComplianceFramework } from "../types";
import { useAvailableFramework } from "./hooks/useAvailableFrameworkCard";

export function AvailableFrameworkCard({
  space,
  framework,
}: {
  space: Space;
  framework: ComplianceFramework;
}) {
  const {
    activateFrameworkDialogOpen,
    downloadFrameworkButton,
    handleActivateFramework,
    activateFramework,
    handleCancelActivateFramework,
  } = useAvailableFramework({ framework, space });

  const iconKey = framework.tags?.find((tag) => tag.key === "mondoo.com/icon");

  const authors =
    framework.authors?.map((author) => author.name).join(", ") || "";

  return (
    <>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          md: 4,
        }}
      >
        <Paper
          className="paper"
          sx={{
            height: "100%",
            p: 3,
            textAlign: "left",
            "&:hover": {
              cursor: "pointer",
            },
          }}
          onClick={() => handleActivateFramework()}
        >
          <Box className="unscale">
            <Grid container sx={{ pb: 2 }} size={12}>
              <Grid
                sx={{ display: "flex", alignItems: "flex-start" }}
                size="grow"
              >
                <FrameworkIcon iconKey={iconKey} />
                <Flex alignItems="center" height={1} sx={{ pl: 2 }}>
                  <Clamp lines={2}>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      color="text.secondary"
                      sx={{ display: "inline-block", lineHeight: "16px" }}
                    >
                      {authors}
                    </Typography>
                  </Clamp>
                </Flex>
              </Grid>
              <Grid size="auto">{downloadFrameworkButton()}</Grid>
            </Grid>
            <Grid sx={{ pb: 1 }} size={12}>
              <Tooltip arrow title={framework.title} placement="top">
                <Clamp>
                  <Typography variant="h5" fontWeight={700}>
                    {framework.title}
                  </Typography>
                </Clamp>
              </Tooltip>
            </Grid>
            <Grid>
              <Clamp lines={3}>
                <Typography variant="body2" color="text.secondary">
                  {framework.description}
                </Typography>
              </Clamp>
            </Grid>
          </Box>
        </Paper>
      </Grid>
      <AvailableFrameworkConfirmDialog
        space={space}
        framework={framework}
        isOpen={activateFrameworkDialogOpen}
        onClose={handleCancelActivateFramework}
        onActivate={activateFramework}
      />
    </>
  );
}
